import React from 'react';
import { PARTNERS } from '../constants';
import { motion } from "framer-motion";

const Partners = () => {
  return (
    <div className=" mx-auto px-20 border-b border-opacity-20 border-gray-400 dark:border-gray-600">
  {PARTNERS.map((partner, index) => (
    <div 
      key={index} 
      className="mt-16 mb-16 flex flex-wrap items-center justify-between gap-8"
    >
      <motion.div
        whileInView={{ opacity: 1, x: 0 }}
        initial={{ opacity: 0, x: index % 2 === 0 ? -100 : 100 }}
        transition={{ duration: 0.5 }}
        className="w-full md:w-1/3 flex justify-center"
      >
        <img
          src={partner.image}
          alt={partner.title}
          className="w-48 h-48 object-cover rounded-full shadow-lg border-4 border-gray-200 dark:border-gray-600"
        />
      </motion.div>
      <motion.div
        whileInView={{ opacity: 1, x: 0 }}
        initial={{ opacity: 0, x: index % 2 === 0 ? 100 : -100 }}
        transition={{ duration: 0.5 }}
        className="w-full md:w-1/2"
      >
        <h6 className="text-2xl mb-4 font-semibold text-text-primary-light dark:text-text-primary-dark">
          {partner.title}
        </h6>
        <p className="text-lg mb-6 text-text-secondary-light dark:text-text-secondary-dark">
          {partner.description}
        </p>
        <div className="flex flex-wrap gap-2">
          {partner.techTags?.map((tag, i) => (
            <span 
              key={i} 
              className="px-3 py-1 rounded-full bg-gray-200 dark:bg-gray-700 text-text-secondary-light dark:text-text-secondary-dark text-sm"
            >
              {tag}
            </span>
          ))}
        </div>
      </motion.div>
    </div>
  ))}
</div>

  );
};

export default Partners;